import React from 'react';
import { Settings, Clock, AlertCircle } from 'lucide-react';

const MaintenancePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse"></div>
          <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse delay-700"></div>
        </div>

        {/* Main content */}
        <div className="relative bg-white rounded-2xl shadow-2xl p-8 md:p-12 border border-gray-100">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-500 rounded-full blur-md opacity-20 animate-pulse"></div>
              <div className="relative bg-gradient-to-br from-blue-500 to-purple-600 rounded-full p-4">
                <Settings className="w-12 h-12 text-white animate-spin" style={{ animationDuration: '3s' }} />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">
            Under Maintenance
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-gray-600 text-center mb-8">
            We're currently performing scheduled maintenance to improve your experience.
          </p>

          {/* Info cards */}
          <div className="space-y-4 mb-8">
            <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg border border-blue-100">
              <Clock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Estimated Duration</h3>
                <p className="text-sm text-gray-600">
                  We'll be back shortly. Thank you for your patience.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-purple-50 rounded-lg border border-purple-100">
              <AlertCircle className="w-5 h-5 text-purple-600 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">What's Happening?</h3>
                <p className="text-sm text-gray-600">
                  We're upgrading our systems to serve you better. Your data is safe and secure.
                </p>
              </div>
            </div>
          </div>

          {/* Contact info */}
          <div className="text-center">
            <p className="text-sm text-gray-500">
              Need urgent assistance?{' '}
              <a 
                href="mailto:support@idsrewards.com" 
                className="text-blue-600 hover:text-blue-700 font-medium underline"
              >
                Contact support
              </a>
            </p>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-100 text-center">
            <p className="text-sm text-gray-400">
              IDsRewards &copy; {new Date().getFullYear()}
            </p>
          </div>
        </div>

        {/* Loading dots indicator */}
        <div className="flex justify-center gap-2 mt-8">
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
